<app-navbar></app-navbar>

<section class="parallax-bg fixed-bg view-height-100vh lg-section" style="background-image: url('assets/images/slides/home-bg-1818.jpg')" id="home">
    <div class="parallax-overlay"></div>
    <div class="hero-text-wrap xxl-screen transparent-bg">
      <div class="hero-text">
        <div class="container">
          <div class="row">
            <div class="col-md-8 centerize-col">
              <div class="all-padding-50 text-center white-color">
                  <h2 class="font-100 raleway-font">S1AZ.COM</h2>
                  <h1>Software 1 A to Z </h1>
                  <h2 class="font-100 raleway-font">ERP Software</h2>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
</section>

<section class="white-bg xs-pb-100" id="features">
    <div class="container">
        <div class="row">
            <div *ngFor="let item of features;" class="col-md-4 col-sm-4 col-xs-12 mb-30 hover-effect">
                <div [ngClass]="item.featureBox">
                    <i [ngClass]="item.icon"></i>
                    <h4 class="mt-0 font-600">{{item.title}}</h4>
                    <p class="font-400">{{item.desc}}</p>
                </div>
            </div>
        </div>
        <div class="row mt-50">
            <div class="col-md-6 col-sm-12">
                <div class="responsive-screen">
                    <img src="assets/images/shop.png" class="img-responsive border-radius-25" alt="about-heading-1" />
                </div>
            </div>
            <div class="col-md-6 col-sm-12 text-left d-flex align-items-center">
                <div class="d-block pl-30 sm-pl-0">
                    <div class="section-title mt-50">
                        <h2 class="raleway-font default-color mt-0">S1AZ.COM your virtual IT Department</h2>
                        <h1 class="raleway-font mt-30 font-50px font-300">Our Awesome Features</h1>
                    </div>
                    <p>Experience seamless trading operations with our powerful ERP software </p>
                    <p>featuring real-time mobile sales, route management, van sales as a mobile sub-depot, instant outlet ledger access, and smart credit control. Manage orders, deliveries, payments, and stock effortlessly, all synchronized across web and mobile platforms to keep your business running smoothly anywhere, anytime.</p>
                    <!--<p class="mt-30 mb-0"><a class="btn btn-lg btn-gradient-secondary btn-square">Read more</a></p>-->
                </div>
            </div>
        </div>
    </div>
</section>

<section class="parallax-bg fixed-bg pt-80 pb-80" style="background-image: url('assets/images/background/parallax-bg1.png')">
    <div class="overlay-bg"></div>
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <div class="section-title mb-50 white-color text-center">
                    <h1 class="raleway-font remove-margin font-50px font-300">Our Process</h1>
                </div>
            </div>
        </div>
        <div class="row our-process-style-02">
            <div *ngFor="let step of steps" class="col-md-3 col-sm-6 col-xs-12 line xs-mb-30 sm-mb-30">
                <div class="icon-wrap white-bg">
                    <div class="icon">
                        <i [ngClass]="step.icon"></i>
                    </div>
                </div>
                <div class="text-center white-color">
                    <h4 class="font-500">{{step.title}}</h4>
                    <p class="mb-0">{{step.desc}}</p>
                </div>
            </div>
        </div>
    </div>
</section>



<section class="white-bg pb-80" id="services">
    <div class="container">
        <div class="row">
            <div class="col-md-8 centerize-col text-center">
                <div class="section-title">
                    <h2 class="raleway-font default-color">What We Offer</h2>
                    <h1 class="raleway-font">Our Services</h1>
                </div>
                <p>We provide customized ERP implementation, mobile and web app development, powerful data analytics with Power BI, comprehensive training and support, regular system maintenance, and expert consultation to optimize your trading business operations.</p>
            </div>
        </div>

        <div class="row mt-50">
            <div *ngFor="let service of services" class="col-md-4 col-sm-4 col-xs-12 mb-30 feature-box text-center hover-effect">
                <div class="gradient-bg-icon mb-20">
                    <i [ngClass]="service.icon"></i>
                </div>
                <h5 class="mt-10">{{service.title}}</h5>
                <p class="font-400">{{service.desc}}</p>
            </div>
        </div>

    </div>
</section>

<section class="gray-bg" id="about">
    <div class="container">
        <div class="row">
            <div class="col-md-8 centerize-col text-center">
                <div class="section-title">
                    <h2 class="raleway-font default-color">We Are S1AZ.COM</h2>
                    <h1 class="raleway-font">About Company</h1>
                </div>
                <p>We are a technology-driven company dedicated to empowering trading businesses with smart, efficient, and fully integrated ERP solutions. Our mission is to simplify complex business operations by delivering reliable software that connects your web and mobile platforms seamlessly.</p>
              <p>With expertise in ERP development, mobile applications, and data analytics, we help businesses optimize their sales, inventory, accounting, and customer management processes. Committed to innovation and customer satisfaction, we provide tailored solutions, ongoing support, and consulting services to ensure your business grows smoothly and efficiently</p>
              <p>Partner with us to transform your trading operations and stay ahead in today’s competitive market.</p>
            </div>
        </div>
        <div class="row mt-50">
            <div class="col-md-7 col-xs-12">
                <img class="img-responsive" src="assets/images/erp.png" alt="laptop">
            </div>
            <div class="col-md-5 mt-30 col-xs-12">
                <div class="skillbar-wrap skillbar-style-01">
                    <div *ngFor="let skill of skills">
                        <div class="skillbar">
                            <span class="skillbar-title text-uppercase">{{ skill.name }}</span>
                            <p class="skillbar-bar gradient-bg" role="progressbar" [style.width]="skill.level + '%'" [attr.aria-valuenow]="skill.level" aria-valuemin="0" aria-valuemax="100"></p>
                            <span class="skill-bar-percent">{{ skill.level }}%</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>






<section class="grey-bg" id="pricings">
    <div class="container">
        <div class="row">
            <div class="col-md-8 centerize-col text-center">
                <div class="section-title mb-50">
                    <h2 class="raleway-font default-color">Maintenance Services</h2>
                    <h1 class="raleway-font">(This pricing is for 1 project / month)</h1>
                </div>
            </div>
        </div>
        <div class="row mt-50">
            <div *ngFor="let price of pricing; let i = index" class="col-md-4 pricing-table col-sm-4 xs-mb-30 hover-effect">
                <div
                    class="pricing-box border-radius-25 {{ i === 1 ? 'pricing-box-gradient-two' : 'pricing-box-gradient' }} text-center white-color">
                    <h3 class="mb-0 raleway-font">{{price.title}}</h3>
                    <h4>{{price.subTitle}}</h4>
                    <h2 class="font-60px sm-font-40px"><sup>{{price.currency}}</sup><span>{{price.amount}}</span></h2>
                    <ul class="list-style-02">
                        <li *ngFor="let feature of price.features">{{ feature }}</li>
                    </ul>
                    <div class="pricing-box-bottom"> <a [ngClass]="price.btnClass">{{price.btnText}}</a> </div>
                </div>
            </div>
        </div>
    </div>
</section>




<div class="grey-bg pt-120 pb-120">
    <div class="container">
        <div class="row">
            <div class="client-slider">
                <owl-carousel-o [options]="customOptionsFour" class="owl-btn-center-lr">
                    <ng-template carouselSlide *ngFor="let slide of slideStoreFour">
                        <div class="client-logo">
                            <img class="img-responsive" src="{{slide.image}}" alt="01" />
                        </div>
                    </ng-template>
                </owl-carousel-o>
            </div>
        </div>

    </div>
</div>



<section class="white-bg transition-none" id="contact">
    <div class="container">
        <div class="row">
            <div class="col-md-8 centerize-col text-center">
                <div class="section-title">
                    <h2 class="raleway-font default-color">Just Keep In Touch</h2>
                    <h1 class="raleway-font">Contact Us Now</h1>
                </div>
                <!--<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aliquam semper ex ac velit varius semper.
                    Mauris at dolor nec ante ultricies aliquam ac vitae diam. Quisque sodales vehicula elementum.
                    Phasellus tempus tellus vitae ullamcorper hendrerit.</p>-->
            </div>
        </div>
    </div>

    <div class="container">
        <div class="row mt-70">
            <div class="col-md-6 col-sm-6 col-xs-12 xs-mb-50">
                <div class="row mt-20">
                    <div class="col-md-6 col-sm-6 col-xs-12">
                        <div class="section-title">
                            <h2 class="raleway-font default-color"> Address</h2>
                            <p class="mt-30">Register: 227, East Rampura, Dhaka, 1219, Bangladesh</p>
                            <p class="mt-30">Office: Plot: 355,  Adarsh Nager Rd, Badda</p>
                        </div>
                    </div>
                    <div class="col-md-6 col-sm-6 col-xs-12">
                        <div class="section-title">
                            <h2 class="raleway-font default-color">Office Numbers</h2>
                          <a href="https://wa.me/8801706088146" target="_blank" style="text-decoration: none;">
                            <p class="mb-0 mt-30">
                              <i class="fa-brands fa-whatsapp" style="color: #63E6BE;"></i>
                              Mobile : +8801706088146
                            </p>
                          </a>
                        </div>
                    </div>
                </div>
                <div class="row mt-20">
                    <div class="col-md-6 col-sm-6 col-xs-12">
                        <div class="section-title">
                            <h2 class="raleway-font default-color">Our Email</h2>
                            <p class="mb-0 mt-30">Website : www.s1az.com</p>
                            <p class="mb-0">Request : contact&#64;s1az.com</p>
                        </div>
                    </div>
                    <div class="col-md-6 col-sm-6 col-xs-12">
                        <div class="section-title">
                            <h2 class="raleway-font default-color">Fast Support</h2>
                            <p class="mb-0 mt-30">Support : contact&#64;s1az.com</p>
                        </div>
                    </div>

                  <div class="col-md-6 col-sm-6 col-xs-12">
                    <div class="section-title">
                      <h2 class="raleway-font default-color">Privacy policy</h2>
                      <p class="mb-0 mt-30"><a href="/privacy-policy-app" target="_blank">Privacy Policy Android</a></p>
                      <p class="mb-0 "> <a href="/privacy-policy" target="_blank">Privacy Policy WhatsApp</a></p>
                      <p class="mb-0 "> <a href="/terms-of-service" target="_blank">Terms Of Service</a></p>



                    </div>
                  </div>
                </div>
            </div>
            <div class="col-md-6 col-sm-6 col-xs-12">
                <form (submit)="apiData($event)" class="contact-form-style-01" #contactForm="ngForm">
                    <div class="row">
                        <div class="col-md-6 col-sm-6">
                            <div class="form-group">
                                <label class="visually-hidden" for="user_name">Name</label>
                                <input type="text" minlength="2" maxlength="15"
                                    [class.is-invalid]="userName.invalid && userName.touched" name="user_name"
                                    class="md-input" id="name" placeholder="Name *" [(ngModel)]="formData.user_name"
                                    #userName="ngModel" required>
                                <div *ngIf="userName.invalid && userName.touched" class="invalid-feedback mb-10">
                                    Name is required.
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6 col-sm-6">
                            <div class="mb-3">
                                <label class="visually-hidden" for="user_email">Email</label>
                                <input type="email" minlength="2" maxlength="35"
                                    [class.is-invalid]="userEmail.invalid && userEmail.touched" name="user_email"
                                    class="md-input" id="email" placeholder="Email *" [(ngModel)]="formData.user_email"
                                    #userEmail="ngModel" required email>
                                <div *ngIf="userEmail.invalid && userEmail.touched" class="invalid-feedback mb-10">
                                    A valid email is required.
                                </div>
                            </div>
                        </div>
                        <div class="col-md-12 col-sm-12">
                            <div class="mb-3">
                                <label class="visually-hidden" for="message">Project Details</label>
                                <textarea name="message" [class.is-invalid]="userMessage.invalid && userMessage.touched"
                                    class="md-textarea" id="message" rows="7" placeholder="Project Details"
                                    [(ngModel)]="formData.message" #userMessage="ngModel" required></textarea>
                                <div *ngIf="userMessage.invalid && userMessage.touched" class="invalid-feedback mb-10">
                                    Project details are required.
                                </div>
                            </div>
                        </div>
                        <div class="col-md-12 col-sm-12">
                            <div class="text-left mt-20">
                                <button type="submit" name="submit"
                                    class="btn btn-outline btn-md btn-circle btn-animate remove-margin"
                                    [disabled]="contactForm.invalid" value="Send">
                                    <span>Send Message <i class="ion-android-arrow-forward"></i></span>
                                </button>
                            </div>
                        </div>
                    </div>
                </form>

            </div>
        </div>
    </div>
</section>
